import AlbumSlideshowMeta from './AlbumSlideshowMeta';

export default AlbumSlideshowMeta;
